<script lang="ts" module>
	export interface TableRowProps {
		dataCy: string;
		index: number;
		children?: import('svelte').Snippet;
		onclick?: (e?: MouseEvent) => void;
		class?: string;
		id?: string;
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';

	let { ...props }: TableRowProps = $props();
</script>

<tr
	id={props.id}
	onclick={props.onclick}
	data-cy={`${props.dataCy}-row`}
	class={twMerge(
		classNames('w-full border-x border-gray-200', {
			'bg-gray-50': !(props.index % 2),
			'cursor-pointer': !!props.onclick
		}),
		props.class
	)}
>
	{@render props.children?.()}
</tr>
